import { AnyAction } from 'redux';
import sendPostMessage from 'src/store/app/operation/sendPostMessage';
import { MESSAGE_TYPE } from 'src/store/app/types';
import { ThunkDispatch } from 'redux-thunk';
import { Store } from 'src/store/index';
import useIntegrationLayer from 'src/util/hook/useIntegrationLayer';
import isEmbroideryProduct from 'src/util/embroidery/isEmbroideryProduct';
import { PrintTechnology } from 'src/store/design/types';

const sendSetDesignDataPostMessageOperation = (designData: any) => (
  dispatch: ThunkDispatch<Store, undefined, AnyAction>,
) => {
  const integrationLayer = useIntegrationLayer();
  const hasEmbroidery = isEmbroideryProduct(integrationLayer.productUid || integrationLayer.internalUid);

  const data = hasEmbroidery && designData?.spreads
    ? {
      ...designData,
      spreads: designData.spreads.map((spread: any) => ({
        ...spread,
        technology: spread.technology || PrintTechnology.Embroidery,
      })),
    }
    : designData;

  sendPostMessage({
    type: MESSAGE_TYPE['design.setDesignData'],
    data,
  });
};

export default sendSetDesignDataPostMessageOperation;
